<template>
  <div
    :id="id"
    :class="`sitebuilder-element-container ${internal_config.fullWidth ? 'full-width-element' : ''}  ${internal_config.fullHeight ? 'full-height-calendar' : ''}`"
    element="BookingCalendarComponent"
    :data-hide-desktop="!internal_config.showDesktop"
    :data-hide-mobile="!internal_config.showMobile"
    :config-properties="JSON.stringify(internal_config)"
    @click="focusElement($event)"
    @contextmenu.prevent="handler($event)"
    :style="style()">

    <vue-draggable-resizable
      @resizing="onResize"
      ref="draggableResizable"
      v-bind:w="parseInt(internal_config.width)"
      v-bind:h="parseInt(internal_config.height)"
      :minWidth="100" :minHeight="(internal_config.fullHeight) ? 720 : 50" :maxHeight="(internal_config.fullHeight) ? 720 : 100000"
      :draggable="false"
      :enable-native-drag="true"
    >
			<rotate
        :target="$refs.draggableResizable"
        :config="internal_config"
      />
			<sync-drag :target="this" />

      <options-element-bar
        ref="optionsBar"
        :elem="this"
        name='ct-component-BookingCalendarComponent'
      >
        <img
          src="static/images/icons/engrenagem.svg"
          v-tooltip="{content:$t('ct-settings'),  class: 'tooltip-custom'}"
          class="svg-icon normal-action"
          @click="openModal"
        />
      </options-element-bar>

      <div class="divBlock" v-show="!preview"/>
      <div
        v-if="internal_config.calendar.src"
        class="embed-responsive embed-responsive-16by9"
        :style="{
          width : width,
          height : internal_config.fullHeight ? '100%' : height,
          minHeight : minHeight
          }"
      >
        <iframe
          :width="internal_config.width"
          :height="internal_config.height"
          :src="internal_config.calendar.src"
          :style="{
            borderRadius: radius,
            border : border
          }"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
          class="embed-responsive-item"
          loading="lazy"
        />
      </div>
      <div v-else>
        <div style="background-color: white; height: 300px; width: 100%; display: flex; align-items: center; justify-content: center; flex-direction: column">
          <h6 class="text-center">{{ $t('ct-select-booking-calendar') }}</h6>
        </div>
      </div>
      <resources ref="resourcesData" />
    </vue-draggable-resizable>
  </div>
</template>
<script>

import Model from './Model';
import Resources from './Resources.vue';
import OptionsElementBar from '../../OptionsElementBar';
import MixinComponents from "../../../../../js/mixins/MixinComponents";

export default {
  name: 'BookingCalendarComponent',
  mixins: [MixinComponents],
  components: {
    OptionsElementBar,
    Resources
  },
  props: ['config', 'device', 'id', 'preview'],
  data() {
    return Model.data();
  },
  computed: {
    minHeight() {
      return this.internal_config.minHeight;
    }
  },
  watch: {
    'internal_config': {
      deep: true,
      handler(value) {
        this.$eventHub.setValueElementConfig(this.id, value);
        this.$eventPointer.log(this.id, value);
      }
    }
  },

  methods: {
    buildCalendar(options) {
      this.internal_config.calendar = options;

      this.internal_config.left = '0px';
      this.internal_config.height = '720px';
      this.internal_config.width = '1024px';
    },
    openModal() {
      this.$root.$emit(
        'openBookingCalendarModal',
        this.internal_config.calendar,
        'bookingCalendarModal',
        this.buildCalendar
      );
    },
    animation() {
      return true;
    },
    onResize(x, y, width, height) {
      this.internal_config.width = width + 'px';
      this.internal_config.height = height + 'px';

      this.$refs.resourcesData.setValuesData(this);
    },
    showResources() {
      return this.$refs.resourcesData.getValuesData();
    },
    changeOrderPanel(elem, idx) {
      if (typeof this.$parent.changeOrderPanel !== 'undefined') {
        this.$parent.changeOrderPanel(this, idx);
      } else {
        this.$parent.$parent.changeOrderPanel(this, idx);
      }
    },
    style() {
      let style = `left:  ${this.internal_config.left};
                     padding-top: ${this.internal_config.paddingTop};
                     padding-left: ${this.internal_config.paddingLeft};
                     z-index: ${this.internal_config.zIndex};max-width: ${this.internal_config.maxWidth};margin: 0 auto;
                     padding-right: ${this.internal_config.paddingRight};
                     padding-bottom: ${this.internal_config.paddingBottom};
                     top: ${this.internal_config.top}`;
      return style;
    },
  },
  created() {
    this.internal_config = Object.assign({}, this.internal_config, window.mergeRecursive(this.props, this.$props.config));
  },
  mounted() {

    this.$refs.resourcesData.setValuesData(this);

    if (this.$props.preview) {
      this.$el.classList.add('preview');
      this.$root.$emit('applyAnimation', this, 'sitebuilder-element-container');
    }

    if (!this.$props.preview && this.internal_config.calendar.src.length === 0){
      this.openModal()
    }
  }
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

  [data-device="desktop"] {
    .full-height-calendar .vdr{
      height: 720px !important;
    }
    .embed-responsive {
      min-height: unset !important;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Booking/Calendar/Calendar.vue